import { LayoutType } from '../types/asset-types';

export const DEFAULT_LAYOUT_OPTION: { value: LayoutType; label: string; icon: string } = {
  value: 'DEFAULT',
  label: 'Original',
  icon: 'IconVideo'
};

export const SCENE_LAYOUT_TYPES: { value: LayoutType; label: string; icon: string }[] = [
  { value: 'SPEAKER', label: 'Fullscreen', icon: 'IconUserScan' },
  { value: 'GRID', label: 'Grid', icon: 'IconLayoutGrid' },
  { value: 'FOCUS', label: 'Focus', icon: 'IconLayoutSidebarRight' },
  { value: 'PIP', label: 'Picture in Picture', icon: 'IconPictureInPicture' }
];

// When a clip is on the new layout engine (feature flag + migration), GRID/FOCUS render as
// SHARED_FILL/FILM_STRIP whenever a screen share is present. The persisted LayoutType values
// (GRID/FOCUS) don't change, only the label shown to the user in scene layout pickers.
export const NEW_ENGINE_SCENE_LAYOUT_LABELS: Partial<Record<LayoutType, string>> = {
  GRID: 'Shared Fill',
  FOCUS: 'Film Strip'
};

export const CLIP_CUSTOMIZER_LAYOUT_TYPES = [
  ...SCENE_LAYOUT_TYPES,
  { value: 'AUDIOGRAM', label: 'Audiogram', icon: 'IconPhotoVideo' },
  DEFAULT_LAYOUT_OPTION
];
